import { useEffect } from 'react';
import { type IFramework } from '@/framework';
import { Layer } from '../..';

export function useDeleteLayerHotkey(framework: IFramework) {
    useEffect(() => {
        const controller = new Layer(framework.identity);
        const deleteHandle = framework.service.hotkey.onDelete(() => {
            const activeInfo = framework.service.frame.getActiveInfo();
            const layerId = activeInfo?.info.pickId || activeInfo?.info.id;
            if (layerId) {
                controller.delete(layerId);
            }
        });

        return () => {
            framework.service.events.off(deleteHandle);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- 仅挂载时注册，与拆分前一致
    }, []);
}
